import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dispatchNavKey } from '../../services/dpad';

// ---------------------------------------------------------------------------
// Bridge between the TV receiver page (/tv, possibly in a cross-origin APK
// iframe) and this app's existing D-pad engine. The receiver posts
// { source:'flexwatch-remote', type:'nav', value } and we replay it as the
// same synthetic keydown a real TV remote would produce, so all existing
// spatial-navigation / activation logic keeps working unchanged.
// ---------------------------------------------------------------------------

const RemoteNavBridge = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const onMessage = (event) => {
      let fromParent = false;
      try {
        fromParent = window.parent && window.parent !== window && event.source === window.parent;
      } catch (err) {
        fromParent = false;
      }
      if (!fromParent) return;

      const data = event.data;
      if (!data || typeof data !== 'object') return;
      if (data.source !== 'flexwatch-remote' || data.type !== 'nav') return;

      dispatchNavKey(data.value, navigate);
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [navigate]);

  return null;
};

export default RemoteNavBridge;
